import React from 'react';
import StaticPage from './StaticPage.jsx';

const PrivacyPage = () => (
    <StaticPage
        title="Privacy — Map Shaper"
        description="What data Map Shaper collects, how it's used, and who it's shared with."
        heading="Privacy"
        intro="A short, honest summary of what data we collect and what happens to it."
    >
        <h2>Using the site without an account</h2>
        <p>
            You can build maps, draw trails and road trips, and shape photos without
            signing up. While you're working, your selections (the places you've
            marked, colours, toggles, an uploaded photo or GPS track) stay in your
            browser — refresh or close the tab and they're gone. Using the site this
            way doesn't require any personal details about you.
        </p>

        <h2>Accounts</h2>
        <p>
            Creating an account is optional and only needed to <em>save</em> maps. You
            can sign up with an email and password, or with Google. We store your email
            address so you can sign back in; if you use Google, we receive your basic
            Google profile (name, email, and profile photo) to set up the account.
            You can delete your account at any time — see “Your data and deleting it”
            below.
        </p>

        <h2>Saved maps (“My Maps”)</h2>
        <p>
            When you click Save, we store that map under your account: its settings
            (the region and places, colours, units, toggles, title), a small thumbnail
            preview, and — where the map needs it — the file behind it (the photo you
            uploaded to the Photo Shaper, or the GPS track you uploaded to Trail Maps).
            These are stored securely on our servers and are private to your account.
            You can rename or delete any saved map from the My Maps page; deleting it
            removes the map and its files.
        </p>

        <h2>When you order a product</h2>
        <p>
            Clicking Order uploads the image of your map or shaped photo so our
            printing partner can fetch it, then opens their checkout. You complete the
            order on the partner's site (Zazzle), where they collect your name,
            address, payment details, and order history under their own privacy policy.
        </p>

        <h2>Photos and GPS files</h2>
        <p>
            A photo or GPS track is processed in your browser. It's only uploaded to
            our storage when you choose to <em>save</em> the map to your account (so it
            can be reopened), or when you <em>order</em> a product (so it can be
            printed). We don't use your uploads for anything else.
        </p>

        <h2>Analytics and ads</h2>
        <p>
            We use standard analytics and advertising tools to understand which
            features people use and to measure how our ads perform. These may set
            cookies and record basic interactions like page views and clicks.
        </p>

        <h2>Sharing</h2>
        <p>
            We don't sell your data. It's shared only with the service providers that
            make the site work — the host that stores your account and saved maps, our
            printing partner, and the analytics and advertising tools above — and only
            for those purposes.
        </p>

        <h2>Your data and deleting it</h2>
        <p>
            You can delete any saved map from My Maps at any time. To delete your whole
            account and the data attached to it, or to ask what we hold about you,
            email <a href="mailto:mapshaped@gmail.com">mapshaped@gmail.com</a> and we'll
            take care of it.
        </p>

        <h2>Contact</h2>
        <p>
            Privacy questions or data requests:{' '}
            <a href="mailto:mapshaped@gmail.com">mapshaped@gmail.com</a>.
        </p>
    </StaticPage>
);

export default PrivacyPage;
